define("ember-cli-flash/components/flash-message", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/string", "@ember/template", "@ember/utils", "@ember/runloop", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _tracking, _string, _template, _utils, _runloop, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/string",0,"@ember/template",0,"@ember/utils",0,"@ember/runloop",0,"@ember/object"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="flash-message {{this.alertType}} {{if this.exiting "exiting"}} {{if this.active "active"}}"
    role="alert"
    ...attributes
    {{on "click" this.onClick}}
    {{did-insert this.onDidInsert}}
    {{will-destroy this.onWillDestroy}}
    {{! template-lint-disable no-invalid-interactive }}
  >
    {{#if (has-block)}}
      {{yield this @flash this.onClose}}
    {{else}}
      {{@flash.message}}
      {{#if this.showProgressBar}}
        <div class="alert-progress">
          <div class="alert-progressBar" style={{this.progressDuration}}></div>
        </div>
      {{/if}}
    {{/if}}
  </div>
  */
  {
    "id": "b48IqueK",
    "block": "[[[11,0],[16,0,[29,[\"flash-message \",[30,0,[\"alertType\"]],\" \",[52,[30,0,[\"exiting\"]],\"exiting\"],\" \",[52,[30,0,[\"active\"]],\"active\"]]]],[24,\"role\",\"alert\"],[17,1],[4,[38,1],[\"click\",[30,0,[\"onClick\"]]],null],[4,[38,2],[[30,0,[\"onDidInsert\"]]],null],[4,[38,3],[[30,0,[\"onWillDestroy\"]]],null],[12],[1,\"\\n\"],[41,[48,[30,3]],[[[1,\"    \"],[18,3,[[30,0],[30,2],[30,0,[\"onClose\"]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[30,2,[\"message\"]]],[1,\"\\n\"],[41,[30,0,[\"showProgressBar\"]],[[[1,\"      \"],[10,0],[14,0,\"alert-progress\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"alert-progressBar\"],[15,5,[30,0,[\"progressDuration\"]]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[]]],[13]],[\"&attrs\",\"@flash\",\"&default\"],false,[\"if\",\"on\",\"did-insert\",\"will-destroy\",\"has-block\",\"yield\"]]",
    "moduleName": "ember-cli-flash/components/flash-message.hbs",
    "isStrictMode": false
  });

  /**
   * ARGS
   *
   * flash: FlashObject
   * messageStyle?: 'bootstrap' | 'foundation'
   * messageStylePrefix?: string
   */
  let FlashMessage = (_dec = (0, _object.computed)('args.flash.exiting'), _dec2 = (0, _object.computed)('messageStyle'), _dec3 = (0, _object.computed)('args.flash.type', 'messageStylePrefix'), _dec4 = (0, _object.computed)('args.flash.type'), _dec5 = (0, _object.computed)('args.flash.{showProgress,timeout}'), (_class = class FlashMessage extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "active", _descriptor, this);

      _initializerDefineProperty(this, "pendingSet", _descriptor2, this);

      _initializerDefineProperty(this, "_mouseEnterHandler", _descriptor3, this);

      _initializerDefineProperty(this, "_mouseLeaveHandler", _descriptor4, this);
    }

    get messageStyle() {
      return this.args.messageStyle ?? 'bootstrap';
    }

    get showProgress() {
      return this.args.flash.showProgress;
    }

    get notExiting() {
      return !this.exiting;
    }

    get showProgressBar() {
      return this.showProgress && this.notExiting;
    }

    get exiting() {
      return this.args.flash.exiting;
    }

    get messageStylePrefix() {
      return this.args.messageStylePrefix ?? this._defaultMessageStylePrefix;
    }

    get _defaultMessageStylePrefix() {
      const isFoundation = this.messageStyle === 'foundation';
      return isFoundation ? 'alert-box ' : 'alert alert-';
    }

    get alertType() {
      const flashType = this.args.flash.type || '';
      const prefix = this.messageStylePrefix;
      return `${prefix}${flashType}`;
    }

    get flashType() {
      return (0, _string.classify)(this.args.flash.type || '');
    }

    get progressDuration() {
      if (!this.args.flash?.showProgress) {
        return false;
      }

      const duration = this.args.flash?.timeout || 0;
      return (0, _template.htmlSafe)(`transition-duration: ${duration}ms`);
    }

    _mouseEnter() {
      if ((0, _utils.isPresent)(this.args.flash)) {
        this.args.flash.preventExit();
      }
    }

    _mouseLeave() {
      if ((0, _utils.isPresent)(this.args.flash) && !this.args.flash.exiting) {
        this.args.flash.allowExit();
      }
    }

    _destroyFlashMessage() {
      if (this.args.flash) {
        this.args.flash.destroyMessage();
      }
    }

    onClick() {
      const destroyOnClick = this.args.flash?.destroyOnClick ?? true;

      if (destroyOnClick) {
        this._destroyFlashMessage();
      }
    }

    onClose() {
      this._destroyFlashMessage();
    }

    onDidInsert(element) {
      const pendingSet = (0, _runloop.next)(this, () => {
        this.active = true;
      });
      this.pendingSet = pendingSet;
      this._mouseEnterHandler = this._mouseEnter;
      this._mouseLeaveHandler = this._mouseLeave;
      element.addEventListener('mouseenter', this._mouseEnterHandler);
      element.addEventListener('mouseleave', this._mouseLeaveHandler);
    }

    onWillDestroy(element) {
      element.removeEventListener('mouseenter', this._mouseEnterHandler);
      element.removeEventListener('mouseleave', this._mouseLeaveHandler);
      (0, _runloop.cancel)(this.pendingSet);

      this._destroyFlashMessage();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "active", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pendingSet", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_mouseEnterHandler", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_mouseLeaveHandler", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "exiting", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "exiting"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_defaultMessageStylePrefix", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "_defaultMessageStylePrefix"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertType", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "alertType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "flashType", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "flashType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "progressDuration", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "progressDuration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_mouseEnter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_mouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_mouseLeave", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_mouseLeave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDidInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDidInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWillDestroy", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWillDestroy"), _class.prototype)), _class));
  _exports.default = FlashMessage;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FlashMessage);
});